import React from "react";
import { BiRupee } from "react-icons/bi";
import { TiTick } from "react-icons/ti";
import img from "../../../Resources/images/japan.jpg";
function MembershipsPlan() {
  const subscriptionsCard = [
    {
      head: "3 month",
      image: img,
      amount: "500",
      descriptions: [
        {
          title: "standard dummy text",
          desc: "There are many variations of data available here",
        },
        {
          title: "randomized words",
          desc: "There are many variations of random services available here",
        },
        {
          title: " free event passes",
          desc: "There are many variations of free events available here",
        },
      ],
    },
    {
      head: "6 month",
      image: img,
      amount: "500",
      descriptions: [
        {
          title: "standard dummy text",
          desc: "There are many variations of data available here",
        },
        {
          title: "randomized words",
          desc: "There are many variations of random services available here",
        },
        {
          title: " free event passes",
          desc: "There are many variations of free events available here",
        },
      ],
    },
    {
      head: "1 year",
      image: img,
      amount: "500",
      descriptions: [
        {
          title: "standard dummy text",
          desc: "There are many variations of data available here",
        },
        {
          title: "randomized words",
          desc: "There are many variations of random services available here",
        },
        {
          title: " free event passes",
          desc: "There are many variations of free events available here",
        },
      ],
    },
  ];
  return (
    <div className="">
      <div className="px-5 my-14 ">
        <div className="grid grid-cols-3 place-items-center gap-7 ">
          {subscriptionsCard.map((val, i) => {
            return (
              <div
                key={i}
                className={`cursor-pointer ${
                  i === 1
                    ? "scale-110  hover:scale-100  "
                    : "scale-100  hover:scale-90 "
                } transition-all rounded-md ease-in-out duration-300 delay-75 
                 w-full h-full bg-white shadow-lg shadow-gray-400 border-t-2 boirder-gray-400   px-5  py-3`}
              >
                <div className="  text-center w-fit  mx-auto py-6   ">
                  <span className="text-3xl capitalize font-semibold">
                    {val.head}
                  </span>{" "}
                  <span className="text-lg font-medium text-gray-500">
                    plan
                  </span>
                </div>
                <div className="w-fit rounded-full mx-auto  my-4">
                  <img
                    src={val.image}
                    alt="Loading"
                    className="rounded-full w-24 h-24 object-cover  border border-gray-400"
                  />
                </div>
                <div className="flex  justify-center items-center">
                  <div className="text-4xl  ">
                    <sup>
                      {" "}
                      <BiRupee />
                    </sup>
                  </div>
                  <div className="">
                    <span className="text-2xl font-semibold">{val.amount}</span>
                    <span> / month</span>
                  </div>
                </div>
                <div className="w-full h-[1px] mt-4 bg-gray-400"></div>
                <div className=" my-8">
                  {val.descriptions.map((value, index) => {
                    return (
                      <div key={i} className="my-3">
                        <div className=" flex gap-2 ">
                          {" "}
                          <div className="mt-1.5">
                            <TiTick className="bg-gray-300   text-gray-800 rounded-full p-[1px]" />
                          </div>{" "}
                          <div>
                            <div className="capitalize text-gray-700 font-medium text-base">
                              {value.title} :
                            </div>
                            <div className=" text-sm text-gray-500">
                              {value.desc}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="text-center bg-gradient-to-l bg-gray-700 via-orange-400
                 from-white  text-white -800 text-base py-1 my-2 font-medium uppercase tracking-wide"
                >
                  subscribe
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className=" mx-auto px-5 capitalize  py-3 text-white text-xl my-6 bg-gray-800 w-[98%] text-center font-semibold">
        our Membership subscription plans
      </div>
    </div>
  );
}

export default MembershipsPlan;
